import { useSelector } from "react-redux";

import RichText from "@/components/atoms/rich-text/rich-text";
import { RootState } from "@/store/root-reducer";

import { useContactDetailsContext } from "../../../provider/contact-details.provider";
import { descriptionSectionCmsData } from "../../../utils/contact-details-page.util";

function ContactDetailsBodyText() {
  const { isFilled } = useSelector((state: RootState) => state.contactDetails);
  const { cmsData } = useContactDetailsContext();
  const { filledStateBodyText, bodyText } = descriptionSectionCmsData(cmsData);

  return (
    <div className="w-full">
      {isFilled ? (
        <div className="font-body-font text-[18px] max-w-full break-words text-center leading-[24px] text-surface-neutral-option-2">
          {filledStateBodyText}
        </div>
      ) : (
        <RichText
          richText={bodyText}
          className="font-body-font text-[18px] max-w-full break-words text-center leading-[24px] text-surface-neutral-option-2"
        />
      )}
    </div>
  );
}
export default ContactDetailsBodyText;
